import {
  StackActions,
  DrawerActions,
  createNavigationContainerRef,
  CommonActions,
} from "@react-navigation/native";
import { strings } from "assets/constants";
import { Linking } from "react-native";

export const navigationRef = createNavigationContainerRef();

// navigator methods .....................

export const nav = navigationRef.navigate;
export const dispatch = navigationRef.dispatch;

// utils
export const _goToBack = () => navigationRef.goBack();
export const _goToRoot = () => dispatch(StackActions.popToTop());
export const _pop = (count: number) => dispatch(StackActions.pop(count));

// splash
export const _goToHomeStack = () =>
  dispatch(
    CommonActions.reset({
      index: 0,
      routes: [{ name: "home" }],
    })
  );

const t = () => {};
// export const _goToHomeStack = () => dispatch(StackActions.replace("home"));

// export const _goToLoginStack = () =>
//   dispatch(
//     CommonActions.reset({ index: 0, routes: [{ name: "login_stack" }] })
//   );

export const _goToLoginStack = () =>
  dispatch(
    CommonActions.reset({
      index: 1,
      routes: [{ name: "insert_mobile" }],
    })
  );

// export const _goToLoginStack = () =>
//   dispatch(StackActions.replace("insert_mobile"));

// auth
export const _goToVerifyCode = (params: IVerifyCode) =>
  nav("verify_code", params);

export const _goToAllTodayReminders = (params: { data: [] }) =>
  nav("all_today_reminders", params);

// organization
export const _goToOrganization = () => nav("organization");
export const _goToEmployeePermissions = (data: {
  user_id?: number;
  name?: string;
}) => nav("employee_permissions", data);

// corporation
export const _goToCorps = () => nav("corps");
export const _goToCorp = (data: { corp?: CorpT }) => nav("corp", data);
export const _goToAddCorp = () => nav("add_corp");
export const _goToCeoS = () => nav("CEOs");
export const _goToCeo = () => nav("CEO");

// user
export const _goToUsers = () => nav("users");
export const _goToUser = (data: { user: {} }) => nav("user", data);

// base
export const _goToTypeOfMeeting = () => nav("type_of_meeting");
export const _goToApkVersion = () => nav("apk_version");

// admin
export const _goToAdmins = () => nav("admins");
export const _goToAddAdmin = () => nav("admin", {});
export const _goToAdmin = (data: { id: number }) => nav("admin", data);

// seller
export const _goToSellers = () => nav("sellers");
export const _goToAddSeller = () => nav("seller", {});
export const _goToSeller = (data: { id: number }) => nav("seller", data);
export const _goToSellerTasks = (data: { id: number; name: string }) =>
  nav("seller_tasks", data);
export const _goToSellerCharts = (data: { id: number; name: string }) =>
  nav("seller_charts", data);

// wholesaler
export const _goToWholesalers = () => nav("wholesalers");
export const _goToAddWholesaler = () => nav("wholesaler");

// attribute
export const _goToAttributes = () => nav("attributes");
export const _goToAddAttribute = () => nav("attribute", {});
export const _goToAttribute = (data: { id: number }) => nav("attribute", data);

// category
export const _goToCategories = () => nav("categories");
export const _goToAddCategory = () => nav("category", {});
export const _goToCategory = (data: { id: number }) => nav("category", data);

// product
export const _goToProducts = () => nav("products");
export const _goToAddProduct = () => nav("product", {});
export const _goToProduct = (data: { id: number; catId: number }) =>
  nav("product", data);

//customer
export const _goToCustomers = (params: ICustomersRoute) =>
  nav("customers", params);
export const _goToCustomersList = () => _goToCustomers({});
export const _goToCustomer = (params: RouteDetailsT) => nav("customer", params);
export const _goToAddCustomer = () => _goToCustomer({});

// reminder
export const _goToReminders = () => nav("reminders", {});
export const _goToRemindersArchive = () =>
  dispatch(StackActions.push("reminders", { archive: true }));
export const _goToAddReminder = () =>
  _goToCustomers({ target: "add_reminder" });
export const _goToReminder = (params: RouteDetailsT) => nav("reminder", params);
export const _goToCustomerReminders = (params: CustomerT) =>
  nav("customer_reminders", params);
export const _goToAddTask = (seller: SellerT) => nav("reminder", { seller });

// factor
export const _goToFactors = () => nav("factors", {});
export const _goToFactorsArchive = () =>
  dispatch(StackActions.push("factors", { archive: true }));
export const _goToAddFactor = () => _goToCustomers({ target: "add_factor" });
export const _goToFactor = (params: RouteDetailsT) => nav("factor", params);
export const _goToAddNewFactorItems = (params: { items: Array<FactorItemT> }) =>
  nav("add_new_factor_items", params);

// note
export const _goToNotes = () => nav("notes");
export const _goToAddNote = () => _goToCustomers({ target: "add_note" });
export const _goToAddNoteForMySelf = () =>
  _goToNote({ customer: { name: strings.myself, id: undefined } });
export const _goToNote = (params: RouteDetailsT) => nav("note", params);
export const _goToEditCustomerNote = (params: RouteDetailsT) =>
  nav("edit_customer_note", params);
export const _goToCustomerNotes = (params: CustomerT) =>
  nav("customer_notes", params);

// report
export const _goToReports = () => nav("reports");
export const _goToSaleReport = (link: string) =>
  nav("report", { link, type: "sale" });
export const _goToSellerReport = (link: string) =>
  nav("report", { link, type: "seller" });
export const _goToProductReport = (link: string) =>
  nav("report", { link, type: "product" });
// export const _goToCustomerReport = (link: string) =>
//   nav("report", { link, type: "customer" });

export const _goToCustomerReport = () => nav("customer_report");

// company
export const _goToCompanies = () => nav("companies");
export const _goToCompany = (id: number) => nav("company", { id });

// others
export const _goToProfile = () => nav("profile");
export const _goToCompanyProfile = () => nav("company_profile");
export const _goToContactUs = () => nav("contact_us");
export const _goToAboutUs = () => {
  _closeDrawer();
  nav("about_us");
};

// drawer
export const _openDrawer = () => dispatch(DrawerActions.openDrawer());
export const _closeDrawer = () => dispatch(DrawerActions.closeDrawer());
export const _goToItsaWebSite = () => Linking.openURL("https://www.itsaco.ir/");

export const _callTo = (number: string) => Linking.openURL("tel:" + number);
export const _mailTo = (email: string) => Linking.openURL("mailto:" + email);
export const _openLink = (link: string) => Linking.openURL(link);

export const _goToCountries = () => nav("countries");

export const _goToTest = () => nav("test");
